import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import HeaderSection from './HeaderSection';
import LeftPanel from './LeftPanel';
import { getHeaderSectionWidthPercentBasedOnSelectedSubGrids } from './selectors';
import { getTaskStatusDisabled } from './TaskStatus/selectors';
import PanelLayout from '../../components/general/PanelLayout';
import DetailForm from '../../form-designer/components/DetailForm';
import FormFooter from '../../form-designer/components/FormFooter';
import StepForm from '../../form-designer/components/StepForm';
import { FORM_KEYS } from '../../form-designer/constants/form-manager.constants';
import { FormContext } from '../../form-designer/context';
import { isFormLoading } from '../../form-designer/selectors/common.selectors';
import { equalityFn } from '../../form-designer/utils/form-manager.utils';
import { getErrorDisplayMessages } from '../../selectors/MessagesSelectors';
import { getUITA } from '../../utils/commonUtils';

const computePanelHeight = (wrapperHeight, headerHeight) => {
  const heightInPx = wrapperHeight - headerHeight;
  return `${(heightInPx * 100) / wrapperHeight}%`;
};

const useStyles = makeStyles({
  headerSection: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 126,
    backgroundColor: '#f8f9fb',
    zIndex: 1000,
    maxWidth: ({ widthPercent }) => `${widthPercent}%`,
  },
});

const DesktopMainSection = ({ wrapperHeight }) => {
  const [headerHeight, setHeaderHeight] = useState(0);

  const isStepFormLoading = useSelector(isFormLoading(FORM_KEYS.STEP));
  const isDetailFormLoading = useSelector(isFormLoading(FORM_KEYS.DETAIL));
  const taskStatusDisabled = useSelector(getTaskStatusDisabled);
  const errors = useSelector(getErrorDisplayMessages, equalityFn);
  const widthPercent = useSelector(getHeaderSectionWidthPercentBasedOnSelectedSubGrids);

  const classes = useStyles({ widthPercent });

  return (
    <Grid container style={{ height: '100%' }}>
      <Grid
        item
        xs={12}
        className={classes.headerSection}
        ui-ta={getUITA('EntityDetailHeaderContainer')}
      >
        <FormContext.Provider value={FORM_KEYS.DETAIL}>
          <HeaderSection onHeightChange={setHeaderHeight} />
        </FormContext.Provider>
      </Grid>
      <Grid item xs={12} style={{ height: computePanelHeight(wrapperHeight, headerHeight) }}>
        <PanelLayout
          leftPanelChildren={<LeftPanel errors={errors} taskStatusDisabled={taskStatusDisabled} />}
          middlePanelChildren={<StepForm isLoading={isStepFormLoading} />}
          middlePanelFormFooter={
            <FormContext.Provider value={FORM_KEYS.STEP}>
              {!isStepFormLoading && <FormFooter />}
            </FormContext.Provider>
          }
          rightPanelChildren={<DetailForm isLoading={isDetailFormLoading} />}
          leftPanelDisabled={taskStatusDisabled && errors.length === 0}
        />
      </Grid>
    </Grid>
  );
};

export default DesktopMainSection;
